import React, {lazy, Suspense} from 'react';

import {AppContext} from '../../AppModule/Context';

import SuspenseLoader from '../common/genericComponents/suspenseLoader/suspenseLoader';

import {ListeningRoomService} from '../../services/websocketService';
import postMessageService from '../../services/postMessageService';
import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';

import './paymentRequestReceiverComponent.css';

const C2cPaymentComponent = lazy(() => import('./c2cPaymentComponent'));

class PaymentRequestReceiverComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      shouldStartPaymentFlow: false,
      sessionTemplateDto: null,
    };
  }

  componentDidMount = () => {
    this.registerListeners();
  };

  componentWillUnmount = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom();
    window.removeEventListener('message', this.paymentListenerFunction); // just in case we had another one
    clearInterval(this.waitForChildWindowCloseInterval);
  };

  registerListeners = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        if (
          data.messageType ===
          VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT
        ) {
          if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST
          ) {
            this.startPaymentFlow(data.content.sessionTemplateDto);
          }
        }
      });
  };

  startPaymentFlow = (sessionTemplateDto) => {
    this.handleUIWhenPaymentFlowStarted();
    const messageToSend = {
      SubType:
        VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST_RECEIVED,
    };
    this.publishToListeningRoom(
      messageToSend,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT,
    );
    this.setState({shouldStartPaymentFlow: true, sessionTemplateDto});
  };

  sendPaymentRequestAcceptedStatus = () => {
    const messageToSend = {
      SubType:
        VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST_ACCEPTED,
    };
    this.publishToListeningRoom(
      messageToSend,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT,
    );
  };

  rejectPayment = () => {
    this.handleToast(
      VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
      'Payment cancelled',
    );
    this.setState({shouldStartPaymentFlow: false});
    const messageToSend = {
      SubType:
        VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST_REJECTED,
    };
    this.publishToListeningRoom(
      messageToSend,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT,
    );
    this.handleUIWhenPaymentFlowCompleted();
  };

  publishToListeningRoom = (messageToSend, messageType) => {
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.extendedMentorDto.mentorDto.mentorOwnerId,
      messageType,
    );
  };

  doWhenPaymentFlowCompletedSuccessfully = (response) => {
    const status = response.status;
    const messageToSend = {
      SubType:
        VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES
          .PAYMENT_POST_PAYMENT_RESOLUTION,
      status,
      // apiKey: paypalPayKey,
    };
    if (status === VIDABOO_CONSTANTS.C2C_CUSTOMER_PAYMENT_SUCCESSFUL_STATUS) {
      //send to client that every thing fine.
      this.publishToListeningRoom(
        messageToSend,
        VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT,
      );
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS);
    } else {
      //send to client that somethng wrong with payment
      this.publishToListeningRoom(
        messageToSend,
        VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT,
      );
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE);
    }
    this.handleUIWhenPaymentFlowCompleted();
  };

  doWhenPaymentFailed = () => {
    //send to client that somethng wrong with payment
    const messageToSend = {
      SubType:
        VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES
          .PAYMENT_POST_PAYMENT_RESOLUTION,
      status: 'FAIL',
    };
    this.publishToListeningRoom(
      messageToSend,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
    );
    this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE);
    this.handleUIWhenPaymentFlowCompleted();
  };

  // createChatMessageData = (messageContent, subtype) => {
  //   const tag = new Date().getTime() + '_' + Math.floor(Math.random() * 1e14);
  //   return {
  //     SubType: subtype
  //       ? subtype
  //       : VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST,
  //     // senderProfileName: this.props.currentUser.profileName,
  //     senderUserId: this.props.currentUser.userId,
  //     message: messageContent,
  //     senderCreationTime: new Date().getTime(),
  //     targetChatRoomId: this.props.chatRoomId,
  //     messageTag:
  //       this.props.chatRoomId + '_' + this.props.currentUser.userId + '_' + tag,
  //   };
  // };

  closePaymentFlow = () => {
    this.setState({
      shouldStartPaymentFlow: false,
    });
    this.handleUIWhenPaymentFlowCompleted();
  };

  handleUIWhenPaymentFlowStarted = () => {
    if (
      this.props.selectedWidgetAppType ===
      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR
    ) {
      postMessageService.postMessageResize(
        VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN,
        'paymentReqReceiverContainer',
      );
    }
  };

  handleUIWhenPaymentFlowCompleted = () => {
    if (
      this.props.selectedWidgetAppType ===
      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR
    ) {
      const actionSelectorHeaderText =
        this.props.extendedMentorDto.mentorDto.appControlDto
          .widgetEditableTexts &&
        this.props.extendedMentorDto.mentorDto.appControlDto
          .widgetEditableTexts[
          VIDABOO_CONSTANTS.WIDGET_APP_HEADER_TITLE_TYPES.ACTION_SELECTOR
        ];
      const postMsgData = {
        foregroundWidgetsLength:
          this.props.extendedMentorDto.mentorDto.appControlDto.foregroundWidgets
            .length,
        actionSelectorHeaderText,
      };
      postMessageService.postMessageResize(
        VIDABOO_CONSTANTS.WIDGET_SIZE.ACTION_SELECTOR,
        'paymentReqReceiverContainer',
        postMsgData,
      );
    }
  };

  handleToast = (toastType, toastTitle) => {
    const tempToastText = toastTitle
      ? toastTitle
      : toastType === VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS
        ? 'Payment success'
        : 'Payment failed';
    const toastObj = utilsService.getToastObj({
      toastTitle: tempToastText,
      toastType,
    });
    this.context.addToastObj(toastObj);
  };

  render() {
    return (
      this.state.shouldStartPaymentFlow &&
      this.state.sessionTemplateDto && (
        <Suspense fallback={<SuspenseLoader />}>
          <C2cPaymentComponent
            shouldStartPaymentFlow={this.state.shouldStartPaymentFlow}
            currentUser={this.props.currentUser}
            mentorDto={this.props.extendedMentorDto.mentorDto}
            sessionTemplateDto={this.state.sessionTemplateDto}
            chatRoomId={this.props.chatRoomId}
            paymentFlowType={
              VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE
                .DURING_CHAT
            }
            closePaymentFlow={this.closePaymentFlow}
            doWhenPaymentFailed={this.doWhenPaymentFailed}
            doWhenPaymentFlowCompletedSuccessfully={
              this.doWhenPaymentFlowCompletedSuccessfully
            }
            rejectPayment={this.rejectPayment}
            sendPaymentRequestAcceptedStatus={
              this.sendPaymentRequestAcceptedStatus
            }
          />
        </Suspense>
      )
    );
  }
}

PaymentRequestReceiverComponent.contextType = AppContext;
export default PaymentRequestReceiverComponent;
